export default __webpack_public_path__ + "static/media/ea-icon.9da69b6f.webp";